import Constants from 'expo-constants';

type ExtraMap = Record<string, unknown>;

const extra = (Constants.expoConfig?.extra ?? {}) as ExtraMap;

const readBooleanFlag = (
  envValue: string | undefined,
  extraKey: string,
  fallback = false,
): boolean => {
  const fromExtra = extra[extraKey];
  const raw =
    envValue ??
    (typeof fromExtra === 'string'
      ? fromExtra
      : typeof fromExtra === 'boolean'
        ? String(fromExtra)
        : undefined);
  if (typeof raw !== 'string') return fallback;
  const normalized = raw.trim().toLowerCase();
  return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on';
};

export const applePlatformFlags = {
  // Use static process.env access so Expo can inline EXPO_PUBLIC_* values in production bundles.
  appGroupId:
    typeof extra.EXPO_PUBLIC_APPLE_APP_GROUP_ID === 'string'
      ? extra.EXPO_PUBLIC_APPLE_APP_GROUP_ID
      : undefined,
  phase5Enabled: readBooleanFlag(process.env.EXPO_PUBLIC_APPLE_PHASE5_ENABLED, 'EXPO_PUBLIC_APPLE_PHASE5_ENABLED', false),
  universalLinksEnabled: readBooleanFlag(
    process.env.EXPO_PUBLIC_APPLE_UNIVERSAL_LINKS_ENABLED,
    'EXPO_PUBLIC_APPLE_UNIVERSAL_LINKS_ENABLED',
    true,
  ),
  widgetNextTripEnabled: readBooleanFlag(
    process.env.EXPO_PUBLIC_APPLE_WIDGET_NEXT_TRIP_ENABLED,
    'EXPO_PUBLIC_APPLE_WIDGET_NEXT_TRIP_ENABLED',
    false,
  ),
  widgetDayBriefingEnabled: readBooleanFlag(
    process.env.EXPO_PUBLIC_APPLE_WIDGET_DAY_BRIEFING_ENABLED,
    'EXPO_PUBLIC_APPLE_WIDGET_DAY_BRIEFING_ENABLED',
    false,
  ),
  spotlightEnabled: readBooleanFlag(process.env.EXPO_PUBLIC_APPLE_SPOTLIGHT_ENABLED, 'EXPO_PUBLIC_APPLE_SPOTLIGHT_ENABLED', false),
  appIntentsReadActionsEnabled: readBooleanFlag(
    process.env.EXPO_PUBLIC_APPLE_APP_INTENTS_READ_ENABLED,
    'EXPO_PUBLIC_APPLE_APP_INTENTS_READ_ENABLED',
    false,
  ),
  appIntentsWriteActionsEnabled: readBooleanFlag(
    process.env.EXPO_PUBLIC_APPLE_APP_INTENTS_WRITE_ENABLED,
    'EXPO_PUBLIC_APPLE_APP_INTENTS_WRITE_ENABLED',
    false,
  ),
  liveActivitiesEnabled: readBooleanFlag(
    process.env.EXPO_PUBLIC_APPLE_LIVE_ACTIVITIES_ENABLED,
    'EXPO_PUBLIC_APPLE_LIVE_ACTIVITIES_ENABLED',
    false,
  ),
};

export type ApplePlatformFlags = typeof applePlatformFlags;
